module.exports = __webpack_public_path__ + "img/TVUPack2.f08d735b.png";